import { ModuleWithProviders, NgModule } from '@angular/core';
import { ORCHESTRATOR_ROUTE_PROVIDERS } from './providers/route.provider';

@NgModule()
export class OrchestratorConfigModule {
  static forRoot(): ModuleWithProviders<OrchestratorConfigModule> {
    return {
      ngModule: OrchestratorConfigModule,
      providers: [ORCHESTRATOR_ROUTE_PROVIDERS],
    };
  }
}
